import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
const Pill = props => (
   <SvgIcon {...props}>
     <defs>
      <path d="M10.0909903,9.31281566 L14.6871843,13.9090097 L19.2478445,9.34834957 C20.5170485,8.07914562 20.5170485,6.02135944 19.2478445,4.75215549 C17.9786406,3.48295154 15.9208544,3.48295154 14.6516504,4.75215549 L10.0909903,9.31281566 Z M10.4090097,20.3085047 C8.55401936,22.1634951 5.54648571,22.1634951 3.69149532,20.3085047 C1.83650494,18.4535143 1.83650494,15.4459806 3.69149532,13.5909903 L13.5909903,3.69149532 C15.4459806,1.83650494 18.4535143,1.83650494 20.3085047,3.69149532 C22.1634951,5.54648571 22.1634951,8.55401936 20.3085047,10.4090097 L10.4090097,20.3085047 Z" id="pill-path-1" />
    </defs>
     <g id="Icon/Product/Pill" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <mask id="pill-mask-2" fill="white">
          <use href="#pill-path-1" />
        </mask>
      <use id="Mask" fill={props.color || '#484848'} fillRule="nonzero" href="#pill-path-1" />
      <g id="Color/Dark-Grey" mask="url(#pill-mask-2)" fill={props.color || '#484848'}>
          <rect id="Rectangle" x="0" y="0" width="24" height="24" />
        </g>
    </g>
   </SvgIcon>
);

export default Pill;



// WEBPACK FOOTER //
// ./src/icons/types/Pill.jsx